// import { useEffect } from "react";
// import "./App.css";
// import { Routes, Route } from "react-router-dom";
// import Dashboard from "../src/dashboard/Dashboard";
// import LoginPage from "./Auth/Login";
// import Registration from "./Auth/Registration";
// import ProtectedRoute from "./Auth/Authentication/ProtectedRoute";
// import PublicRoute from "./Auth/Authentication/PublicRoute";
// import { startTokenWatcher, isTokenExpired } from './Services/tokenHelper';

// function App() {
//   useEffect(() => {
//     const token = localStorage.getItem('access');

//     if (token && !isTokenExpired()) {
//       startTokenWatcher();
//     } else if (token && isTokenExpired()) {
//       localStorage.clear();
//     }
//   }, []);

//   return (
//     <Routes>
//       {/* 🔓 Public Routes */}
//       <Route
//         path="/"
//         element={
//           <PublicRoute>
//             <LoginPage />
//           </PublicRoute>
//         }
//       />
//       <Route
//         path="/register"
//         element={
//           <PublicRoute>
//             <Registration />
//           </PublicRoute>
//         }
//       />

//       {/* 🔒 Protected Routes - Direct Dashboard without division page */}
//       <Route
//         path="/dashboard/*"
//         element={
//           <ProtectedRoute>
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />
//     </Routes>
//   );
// }

// export default App;















import { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../src/dashboard/Dashboard";
import LoginPage from "./Auth/Login";
import Registration from "./Auth/Registration";
import ProtectedRoute from "./Auth/Authentication/ProtectedRoute";
import PublicRoute from "./Auth/Authentication/PublicRoute";
import { startTokenWatcher, isTokenExpired } from './Services/tokenHelper';
import DivisionPage from "./dashboard/components/Divisions";
import DivisionGuard from "./dashboard/components/DivisionGuard";
import MarkAttendance from "./dashboard/components/Attendance/MarkAttendance";

// ✅ NEW: Employee Public Routes (No admin login)
import EmployeeLogin from "./dashboard/components/Attendance/Employee/EmployeeLogin";
import EmployeeDashboard from "./dashboard/components/Attendance/Employee/EmployeeDashboard";
import EmployeeMyAttendance from "./dashboard/components/Attendance/Employee/EmployeeMyAttendance";
import EmployeeProtectedRoute from "./dashboard/components/Attendance/Employee/EmployeeProtectedRoute";

function App() {
  useEffect(() => {
    const token = localStorage.getItem('access');

    // Token hai aur valid hai tabhi watcher start karo
    if (token && !isTokenExpired()) {
      startTokenWatcher();
    } else if (token && isTokenExpired()) {
      localStorage.clear();
    }
  }, []);

  return (
    <Routes>

      {/* ═══════════════════════════════════════════ */}
      {/* 🔓 ADMIN PUBLIC ROUTES                       */}
      {/* ═══════════════════════════════════════════ */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Registration />
          </PublicRoute>
        }
      />

      {/* ═══════════════════════════════════════════ */}
      {/* 🌐 GOOGLE LENS PUBLIC ATTENDANCE             */}
      {/* ═══════════════════════════════════════════ */}
      <Route
        path="/mark-attendance"
        element={<MarkAttendance />}
      />

      {/* ═══════════════════════════════════════════ */}
      {/* 👤 EMPLOYEE APP ROUTES (Separate login)      */}
      {/* ═══════════════════════════════════════════ */}

      {/* Employee Login (Public) */}
      <Route
        path="/employee-login"
        element={<EmployeeLogin />}
      />

      {/* Employee Dashboard (Protected by Employee Auth) */}
      <Route
        path="/employee-dashboard"
        element={
          <EmployeeProtectedRoute>
            <EmployeeDashboard />
          </EmployeeProtectedRoute>
        }
      />

      {/* Employee My Attendance (Protected by Employee Auth) */}
      <Route
        path="/employee-attendance-history"
        element={
          <EmployeeProtectedRoute>
            <EmployeeMyAttendance />
          </EmployeeProtectedRoute>
        }
      />

      {/* ═══════════════════════════════════════════ */}
      {/* 🔒 ADMIN PROTECTED ROUTES                    */}
      {/* ═══════════════════════════════════════════ */}
      <Route
        path="/division-cards"
        element={
          <ProtectedRoute>
            <DivisionPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <DivisionGuard>
              <Dashboard />
            </DivisionGuard>
          </ProtectedRoute>
        }
      />

    </Routes>
  );
}

export default App;